import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { UsersHelper } from '../../helpers/usersHelper';

function LicenseTypePermissions(props) {
  const allowedLicenseType = useSelector(state => state.AUTH.licenseType);

  const allowHempLicenses = [
    UsersHelper.LICENSE_TYPE_SELECT_OPTIONS[0].value,
    UsersHelper.LICENSE_TYPE_SELECT_OPTIONS[2].value,
  ];
  const allowCannabisLicenses = [
    UsersHelper.LICENSE_TYPE_SELECT_OPTIONS[1].value,
    UsersHelper.LICENSE_TYPE_SELECT_OPTIONS[2].value,
  ];

  const { type } = props;

  if (
    (type === UsersHelper.LICENSE_TYPE_SELECT_OPTIONS[0].label &&
      allowHempLicenses.includes(allowedLicenseType)) ||
    (type === UsersHelper.LICENSE_TYPE_SELECT_OPTIONS[1].label &&
      allowCannabisLicenses.includes(allowedLicenseType))
  ) {
    return <Outlet />;
  }
  return null;
}

LicenseTypePermissions.propTypes = {
  type: PropTypes.string.isRequired,
};

export default LicenseTypePermissions;
